import Cookies from 'js-cookie'
const TokenKey = 'token'
const RefreshTokenKey = 'refresh_token'
const UserIdKey = 'user_id'
const UserRealNameKey = 'user_real_name'
const BrandIdKey = 'brand_id'
const BrandTitleKey = 'brand_title'
const SiteIdKey = 'site_id'
const SiteTitleKey = 'site_title'
const SiteLogeImgSm = 'site_logo'
const SiteInvoiceCode = 'site_invoice_code'
const SiteInvoiceHashKey = 'site_invoice_hash_key'
const SiteInvoiceHashIv = 'site_invoice_hash_iv'
const SitePaymentFlowCode = 'site_payment_flow_code'
const SitePaymentFlowHashKey = 'site_payment_flow_hash_key'
const SitePaymentFlowHashIv = 'site_payment_flow_hash_iv'
const SiteVenueReservationDaysLimit = 'site_venue_reservation_days_limit'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function getRefreshToken() {
  return Cookies.get(RefreshTokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function setRefreshToken(token) {
  return Cookies.set(RefreshTokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function removeRefreshToken() {
  return Cookies.remove(RefreshTokenKey)
}

/**
 * 取得品牌Id cookie
 */
export function getBrandId() {
  return Cookies.get(BrandIdKey)
}

/**
 * 取得品牌名稱 cookie
 */
export function getBrandTitle() {
  return Cookies.get(BrandTitleKey)
}

/**
 * 取得場館Id cookie
 */
export function getSiteId() {
  return Cookies.get(SiteIdKey)
}

/**
 * 取得場館名稱 cookie
 */
export function getSiteTitle() {
  return Cookies.get(SiteTitleKey)
}

/**
 * 儲存品牌Id cookie
 */
export function setBrandId(brandId) {
  return Cookies.set(BrandIdKey, brandId)
}

/**
 * 儲存品牌名稱 cookie
 */
export function setBrnadTitle(brandTitle) {
  return Cookies.set(BrandTitleKey, brandTitle)
}

/**
 * 儲存場館Id cookie
 */
export function setSiteId(siteId) {
  return Cookies.set(SiteIdKey, siteId)
}

/**
 * 儲存場館名稱 cookie
 */
export function setSiteTitle(siteTitle) {
  return Cookies.set(SiteTitleKey, siteTitle)
}

/**
 * 取得使用者Id cookie
 */
export function getUserId() {
  return Cookies.get(UserIdKey)
}

/**
 * 儲存使用者Id cookie
 */
export function setUserId(userId) {
  return Cookies.set(UserIdKey, userId)
}

/**
 * 刪除使用者Id cookie
 */
export function removeUserId() {
  return Cookies.remove(UserIdKey)
}

/**
 * 取得使用者名字 cookie
 */
export function getUserRealName() {
  return Cookies.get(UserRealNameKey)
}

/**
 * 儲存使用者名字 cookie
 */
export function setUserRealName(name) {
  return Cookies.set(UserRealNameKey, name)
}

/**
 * 刪除使用者名字 cookie
 */
export function removeUserRealName() {
  return Cookies.remove(UserRealNameKey)
}

/**
 * 取得場館Logo cookie
 */
export function getSiteLogoImgSm() {
  return Cookies.get(SiteLogeImgSm)
}

/**
 * 儲存場館Logo cookie
 */
export function setSiteLogoImgSm(url) {
  return Cookies.set(SiteLogeImgSm, url)
}

/**
 * 刪除場館Logo cookie
 */
export function removeSiteLogoImgSm() {
  return Cookies.remove(SiteLogeImgSm)
}

/**
 * 取得場館發票設定(綠界)- 商店代號
 */
export function getSiteInvoiceCode() {
  return Cookies.get(SiteInvoiceCode)
}

/**
 * 儲存場館發票設定(綠界)- 商店代號
 */
export function setSiteInvoiceCode(code) {
  return Cookies.set(SiteInvoiceCode, code)
}

/**
 * 刪除場館發票設定(綠界)- 商店代號
 */
export function removeSiteInvoiceCode() {
  return Cookies.remove(SiteInvoiceCode)
}

/**
 * 取得場館發票設定(綠界)- HashKey
 */
export function getSiteInvoiceHashKey() {
  return Cookies.get(SiteInvoiceHashKey)
}

/**
 * 儲存場館發票設定(綠界)- HashKey
 */
export function setSiteInvoiceHashKey(key) {
  return Cookies.set(SiteInvoiceHashKey, key)
}

/**
 * 刪除場館發票設定(綠界)- HashKey
 */
export function removeSiteInvoiceHashKey() {
  return Cookies.remove(SiteInvoiceHashKey)
}

/**
 * 取得場館發票設定(綠界)- HashIV
 */
export function getSiteInvoiceHashIv() {
  return Cookies.get(SiteInvoiceHashIv)
}

/**
 * 儲存場館發票設定(綠界)- HashIV
 */
export function setSiteInvoiceHashIv(iv) {
  return Cookies.set(SiteInvoiceHashIv, iv)
}

/**
 * 刪除場館發票設定(綠界)- HashIV
 */
export function removeSiteInvoiceHashIv() {
  return Cookies.remove(SiteInvoiceHashIv)
}

/**
 * 取得場館金流設定(綠界)-商店代號
 */
export function getSitePaymentFlowCode() {
  return Cookies.get(SitePaymentFlowCode)
}

/**
 * 儲存場館金流設定(綠界)-商店代號
 */
export function setSitePaymentFlowCode(code) {
  return Cookies.set(SitePaymentFlowCode, code)
}

/**
 * 刪除場館金流設定(綠界)-商店代號
 */
export function removeSitePaymentFlowCode() {
  return Cookies.remove(SitePaymentFlowCode)
}

/**
 * 取得場館金流設定(綠界)- HashKey
 */
export function getSitePaymentFlowHashKey() {
  return Cookies.get(SitePaymentFlowHashKey)
}

/**
 * 儲存場館金流設定(綠界)- HashKey
 */
export function setSitePaymentFlowHashKey(key) {
  return Cookies.set(SitePaymentFlowHashKey, key)
}

/**
 * 刪除場館金流設定(綠界)- HashKey
 */
export function removeSitePaymentFlowHashKey() {
  return Cookies.remove(SitePaymentFlowHashKey)
}

/**
 * 取得場館金流設定(綠界)- HashIV
 */
export function getSitePaymentFlowHashIv() {
  return Cookies.get(SitePaymentFlowHashIv)
}

/**
 * 儲存場館金流設定(綠界)- HashIV
 */
export function setSitePaymentFlowHashIv(iv) {
  return Cookies.set(SitePaymentFlowHashIv, iv)
}

/**
 * 刪除場館金流設定(綠界)- HashIV
 */
export function removeSitePaymentFlowHashIv() {
  return Cookies.remove(SitePaymentFlowHashIv)
}

/**
 * 取得最多可預約幾天後的場地
 */
export function getSiteVenueReservationDaysLimit() {
  var days = Cookies.get(SiteVenueReservationDaysLimit);
  if(isNaN(days)){
    return 7;
  }
  return parseInt(days)
}

/**
 * 儲存最多可預約幾天後的場地
 */
export function setSiteVenueReservationDaysLimit(days) {
  return Cookies.set(SiteVenueReservationDaysLimit, days)
}

/**
 * 刪除最多可預約幾天後的場地
 */
export function removeVenueReservationDaysLimit() {
  return Cookies.remove(SiteVenueReservationDaysLimit)
}